import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  mainHeader: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginTop: 10,
  },
  imgWrapper: {
    display: 'flex',
    width: '100%',
    height: 200,
    boxSizing: 'border-box',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 5,
    border: '2px solid #fff',
  },
  imgWrapperMobile: {
    width: '100%',
  },
  imgBack: {
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    height: '100%',
    width: '100%',
    position: 'absolute',
  },
  img: { maxHeight: '100%', maxWidth: '100%', zIndex: 2, position: 'relative' },
  mainHeaderBorder: {
    borderLeft: '20px solid #444',
    height: 5,
    marginRight: 10,
  },
  mainHeaderText: {
    whiteSpace: 'nowrap',
  },
  mainHeaderBorderEnd: {
    width: '100%',
    background: '#444',
    height: 5,
    marginLeft: 10,
  },
  subHeader: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginTop: 10,
  },
  subHeaderBorder: {
    borderLeft: '20px solid #444',
    height: 5,
    marginRight: 10,
  },
  card: {
    boxShadow: '0px 10px 30px -5px rgba(0, 0, 0, 0.3)',
    transition: 'box-shadow 0.5s',
    willChange: 'transform',
    maxWidth: 500,
    marginBottom: 20,
    boxSizing: 'border-box',
  },
  cardMobile: { width: '100% !important' },
  testimonialWrapper: {
    maxWidth: '500px',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  projectWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'nowrap',
    flexDirection: 'row',
    marginTop: 30,
    boxSizing: 'border-box',
  },
  projectWrapperParent: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    flexWrap: 'wrap',
    flexDirection: 'column',
    marginBottom: 30,
  },
  projectWrapperItem: {
    minWidth: 200,
    maxWidth: 200,
    maxHeight: 200,
    minHeight: 200,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    boxShadow: '10px 10px 30px rgba(0,0,0,0.4)',
  },
  projectWrapperItemMissing: {
    background: theme.palette.primary.main,
    color: '#fff',
  },
  projectName: {
    width: '100%',
    background: 'rgba(0,0,0,0.6)',
    color: '#fff',
    textAlign: 'center',
    padding: 5,
    boxSizing: 'border-box',
  },
  testimonialWrapperParent: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    flexWrap: 'wrap',
    flexDirection: 'column',
  },
  testimonialWrapperItem: {
    width: 60,
    height: 60,
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    borderRadius: '50%',
    border: '3px solid #ddd',
  },
  testimonialSummaryWrapper: {
    borderRadius: 40,
    padding: 15,
    minWidth: 200,
    marginLeft: 10,
  },
  projectSummaryWrapper: {
    borderRadius: 40,
    padding: 15,
    minWidth: 200,
    marginLeft: 10,

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%',
  },

  projectSummary: {
    width: '100%',
    textAlign: 'center',
    paddingTop: 10,
  },
  testimonialSummary: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  testimonialName: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    textAlign: 'center',
  },
}));
